module.exports = __webpack_public_path__ + "static/img/A142.109f2ee4.jpg";